<template>
  <CommonLayout footer="floristFooter">
    <FloristHeader @suggestion="suggestion" />
    <MeetingLayout :type="consts.meetingType.florist">
      <div class="base-color mh-550 shadow">
        <BOverlay :show="overlayShow" rounded="sm">
          <div class="p-2">
            <div class="row">
              <div class="col-sm-6 p-3">
                <span>画像を選択してください。</span>
              </div>
              <div class="col-sm-6 text-end p-3">
                <!-- Buttons are commented out as before -->
              </div>
            </div>

            <div class="col-sm-12">
              <!-- Bootstrap5: card-columns は削除されたので row/col に置換 -->
              <div
                v-for="(rowImages, rowIndex) in suggestionProductRows"
                :key="rowIndex"
                class="row row-cols-1 row-cols-sm-2 g-3 p-3"
              >
                <div
                  v-for="styleImage in rowImages"
                  :key="styleImage.projectNumber"
                  class="col"
                >
                  <div class="card position-relative border-0 bg-unset card-sqr-gray">
                    <div class="p-0 h-100" @click="nextPage(styleImage.projectNumber)">
                      <img :src="styleImage.imagePath" class="ar-3-2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BOverlay>
      </div>
    </MeetingLayout>

    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>

<script>
import { BOverlay } from 'bootstrap-vue-next' // グローバル登録済みなら不要
import CommonModal from '@/components/CommonModal'
import CommonLayout from '@/layout/CommonLayout'
import MeetingLayout from '@/layout/MeetingLayout'
import FloristHeader from '@/components/FloristHeader.vue'
import SuggestionProductModel from '@/models/SuggestionProductModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import mstore from '@/store/meeting-store'
import fstore from '@/store/florist-store'

export default {
  name: 'FloristMeetingProductProposal',
  components: { CommonModal, CommonLayout, MeetingLayout, FloristHeader, BOverlay },

  data () {
    return {
      overlayShow: false,
      imageRowMaxNum: 2,
      isSendFirstSignalingData: false,
      isProjectTypeMain: false,
      images: [],
      suggestionData: null
    }
  },

  computed: {
    getIsTargetAtendeeActive () {
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    suggestionProductRows () {
      if (!this.images.length) return []
      const length = Math.ceil(this.images.length / this.imageRowMaxNum)
      return new Array(length).fill(null).map((_, i) =>
        this.images.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
    }
  },

  watch: {
    getIsTargetAtendeeActive (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },

    getSignalingData (newData, oldData) {
      try {
        if (!newData) return

        if (newData.event !== 'api') {
          newData.user = 'florist'
          newData.timestampMs = Date.now()
          CommonLogModel.apiSetStore(this.$refs.commonModal, newData, () => {})
        }

        if (newData.event === 'again') {
          this.sendSignalingApiData()
          return
        }

        if (newData.current_path && oldData) {
          const synchPass = newData.current_path.replace('customer', 'florist')
          if (synchPass !== this.$route.path) {
            this.$router.push(synchPass)
            return
          }
        }

        if (!fstore.getters.isOperationPossible) {
          if (newData.event === 'click' && newData.id === 'next') {
            sessionStorage.setItem('scrollY', String(window.scrollY))
            sessionStorage.setItem('proposalScrollHistoryFlag', 'True')
            this.$router.push(newData.target_path)
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(
          this.$refs.commonModal,
          { timestampMs: Date.now(), errorMessage: err?.message ?? String(err) },
          () => {}
        )
      }
    }
  },

  methods: {
    readSuggestionData () {
      try {
        const raw = localStorage.getItem('suggestionData')
        return raw ? JSON.parse(raw) : null
      } catch {
        return null
      }
    },
    async setApiData (isReload = false) {
      this.overlayShow = true
      this.images = []

      this.suggestionData = this.readSuggestionData()
      const suggestionData = this.suggestionData

      if (!suggestionData) {
        this.overlayShow = false
        return this.$refs.commonModal?.msgBoxOk?.('提案条件を設定してください')
      }

      if (isReload && SuggestionProductModel.getStore()) {
        SuggestionProductModel.removeStore()
      }

      const currentProjectType = suggestionData.projectType?.[0]
      if (!currentProjectType) {
        this.overlayShow = false
        return this.$refs.commonModal?.msgBoxOk?.('提案条件を設定してください')
      }

      if (this.consts.projectType.finish.includes(currentProjectType)) {
        this.overlayShow = false
        return this.$router.push('/florist/meeting/estimate')
      }

      try {
        await SuggestionProductModel.apiSetStore(this.$refs.commonModal, suggestionData, () => {
          this.overlayShow = false
        })
      } catch (e) {
        this.overlayShow = false
        return false
      }

      const store = SuggestionProductModel.getStore()
      this.images = store?.images ? [...store.images] : []

      this.isProjectTypeMain = this.consts.projectType.main.includes(currentProjectType)

      if ((!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) || isReload) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },

    sendSignalingApiData () {
      this.suggestionData = this.readSuggestionData()
      const store = SuggestionProductModel.getStore()
      if (!store?.images?.length || !this.suggestionData) return

      const projectType = this.suggestionData.projectType?.[0] ?? ''
      const suggestionType = this.suggestionData.suggestionType?.[0] ?? ''

      const count = store.images.length
      let chunk = []

      for (let i = 0; i < count; i++) {
        chunk.push({
          status: store.status,
          message: store.message,
          images: store.images[i],
          imageSort: i,
          project_type: projectType,
          suggestion_type: suggestionType
        })

        // 3つずつまとめて送る
        if ((i + 1) % 3 === 0 || i === count - 1) {
          SignalingModel.sendApiEvent('getSuggestionProduct', this, chunk)
          chunk = []
        }
      }
    },

    nextPage (projectNumber) {
      this.suggestionData = this.readSuggestionData()
      if (!fstore.getters.isOperationPossible || !this.suggestionData) return

      sessionStorage.setItem('scrollY', String(window.scrollY))
      sessionStorage.setItem('proposalScrollHistoryFlag', 'True')

      const targetPath = `/florist/meeting/product_selection/${projectNumber}`
      const projectType = this.suggestionData.projectType?.[0] ?? ''
      const suggestionType = this.suggestionData.suggestionType?.[0] ?? ''

      this.$router.push({ path: targetPath, query: { projectType, suggestionType } })

      SignalingModel.sendClickEvent('next', this, {
        target_path: targetPath.replace('florist', 'customer'),
        project_number: projectNumber
      })
    },

    backPage () {
      const targetPath = '/florist/meeting/style_image_proposal'
      SignalingModel.sendClickEvent('back', this, { target_path: targetPath.replace('florist', 'customer') })
      this.$router.push(targetPath)
    },

    reload () {
      SignalingModel.sendClickEvent('reload', this)
      this.setApiData(true)
    },

    suggestion () {
      this.suggestionData = this.readSuggestionData()
      window.scrollTo(0, 0)
      const currentProjectType = this.suggestionData?.projectType?.[0]
      if (currentProjectType && this.consts.projectType.finish.includes(currentProjectType)) {
        this.$router.push('/florist/meeting/estimate')
      } else {
        SignalingModel.sendClickEvent('reload', this)
        this.setApiData(true)
      }
    }
  },

  async mounted () {
    await this.setApiData()

    if (sessionStorage.getItem('proposalScrollHistoryFlag') === 'True') {
      const y = sessionStorage.getItem('scrollY')
      if (y != null) window.scrollTo(0, Number(y))
    } else {
      window.scrollTo(0, 0)
    }
  },

  unmounted () {
    if (SuggestionProductModel.getStore()) {
      SuggestionProductModel.removeStore()
    }
  }
}
</script>
